export default "/images/map-expo-mesto.png?2188b788595aa212bd3970965034e89d";